export default __webpack_public_path__ + "static/media/stop.8b61a64a.png";